module.exports = __webpack_public_path__ + "img/homelisticon5.0394bfb8.png";